import { Typography } from '@mui/material';


import { withStyles } from 'tss-react/mui';


export const CardSubtitle = withStyles(Typography, {
  root: {
    fontWeight: 700,
    lineHeight: '260%',
    textTransform: 'uppercase',
  },
  body1: {
    fontSize: '12px',
    lineHeight: '32px',
  }
});
